import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'General',
    [Tab.SignedLive]: 'Semnat / Live',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Comision',
  },
};
